/* ---------------------------------------------------------------
   Optik-Schicht fuer das Antwortfenster im Shop (Tiefgruen-Design
   vom 14.08.2026). Alles, was den Bildschirm anfasst, steht hier.
   Die Wissensschicht (kuno-logik.js) bleibt unberuehrt — sie ist
   dieselbe, die die Testsuite absichert.
   --------------------------------------------------------------- */
let current = [results.snack];
let aktiveFilter = [];
let kunoOffen = false;
const el = id => document.getElementById(id);

/* ---- Live-Daten: Preise, Lieferbarkeit und Produktlinks kommen
   beim Seitenaufruf aus dem Shop und ueberschreiben den Schnappschuss.
   Schlaegt der Abruf fehl, bleiben die Schnappschuss-Werte stehen. ---- */
function liveAbgleich(){
  const proSeite = 250;
  const lade = seite => fetch('/collections/gesamtes-sortiment/products.json?limit=' + proSeite + '&page=' + seite)
    .then(r => r.ok ? r.json() : { products: [] })
    .catch(() => ({ products: [] }));
  Promise.all([lade(1), lade(2)]).then(seiten => {
    const beiSku = {};
    seiten.forEach(s => (s.products || []).forEach(prod => {
      (prod.variants || []).forEach(v => {
        if (v.sku && !beiSku[v.sku]) beiSku[v.sku] = { prod: prod, variante: v };
      });
    }));
    let getroffen = 0;
    PRODUKTE.forEach(p => {
      const treffer = beiSku[p.s];
      if (!treffer) return;
      getroffen++;
      const preis = parseFloat(treffer.variante.price);
      if (!isNaN(preis) && preis > 0) p.p = preis;
      p.lieferbar = treffer.variante.available !== false;
      p.url = '/products/' + treffer.prod.handle;
      /* Bio-Kennzeichen aus dem Shop: Tag "bio" oder Produkttyp.
         Ein im Titel erkanntes Bio wird nie zurückgenommen. */
      var etiketten = (treffer.prod.tags || []).map(function (t) { return String(t).toLowerCase(); });
      if (etiketten.indexOf('bio') !== -1 || etiketten.indexOf('bio-qualität') !== -1) p.bio = 1;
    });
    if (kunoOffen && getroffen) render(current);
  });
}

function karte(p){
  const g = grundpreis(p);
  const inner =
    '<div class="pimg"><img src="'+p.i+'" alt="" loading="lazy"></div>'
   +'<div class="pbody"><h3>'+kurz(p.t)+'</h3>'
   +'<div class="pnotiz">'+(notizen(p).length?notizen(p).join(' · '):'<span class="warn">noch nicht verkostet</span>')+'</div>'
   +'<div class="pmenge">'+mengeText(p)+(p.koffein?' · enthält Koffein':'')+'</div>'
   +'<div class="ppreis">'+eur(p.p)+'</div>'
   +'<div class="pgrund">'+(g?eur(g.wert)+' je '+g.einheit:'<span class="warn">Füllmenge fehlt</span>')+'</div>'
   +(p.lieferbar===false
      ? '<div class="plief plief--aus"><span class="punkt punkt--aus"></span>derzeit nicht lieferbar</div>'
      : '<div class="plief"><span class="punkt"></span>lieferbar</div>')
   +'<div class="pnr">Art. '+p.s+'</div>'
   +'</div>';
  if (p.url) return '<a class="pcard" href="'+p.url+'" data-nr="'+p.s+'">'+inner+'</a>';
  return '<article class="pcard" data-nr="'+p.s+'">'+inner+'</article>';
}

function rezeptKarte(r){
  return '<a class="rzcard" href="'+rezeptURL(r.h)+'" target="_blank" rel="noopener">'
   +'<div class="rzimg"><img src="'+r.b+'" alt="" loading="lazy"></div>'
   +'<div class="rzt">'+r.t+'</div></a>';
}
function erzeugerKarte(r){
  return '<a class="rzcard" href="'+erzeugerURL(r.h)+'" target="_blank" rel="noopener">'
   +'<div class="rzimg"><img src="'+r.b+'" alt="" loading="lazy"></div>'
   +'<div class="rzt">'+r.t+'</div></a>';
}

function sortiere(liste){
  const v=el('sortSel').value, l=liste.slice();
  if(v==='rang')    return l; /* Reihenfolge der Antwort ist eine Aussage (z. B. Verkaufsrang) */
  if(v==='preis')   l.sort((a,b)=>a.p-b.p);
  if(v==='preisab') l.sort((a,b)=>b.p-a.p);
  if(v==='name')    l.sort((a,b)=>kurz(a.t).localeCompare(kurz(b.t),'de'));
  if(v==='grund')   l.sort((a,b)=>((grundpreis(a)||{wert:1e9}).wert)-((grundpreis(b)||{wert:1e9}).wert));
  return l;
}

/* Filterknoepfe entstehen aus den vorhandenen Notizen, nie aus
   erfundenen Eigenschaften. Unter zwei Notizen keine Zeile. */
function baueFilter(liste){
  /* Seit 15.08.2026 stammen die Knoepfe aus allen Begriffen eines
     Artikels - bei den verkosteten Honigen also aus fuenf Noten plus
     der Konsistenz, nicht mehr aus einem Titelwort. */
  const worte=[...new Set(liste.flatMap(p=>notizen(p)))];
  aktiveFilter=aktiveFilter.filter(f=>worte.includes(f));
  el('filterChips').innerHTML = worte.length<2 ? '' :
    worte.map(n=>'<button class="kchip'+(aktiveFilter.includes(n)?' an':'')+'" data-filter="'+n+'">'+n+'</button>').join('');
}

function seitenspalte(result, liste){
  const boxen=[];
  const k=liste.length?liste[0].k:null;
  if(liste.length>1 && liste.every(p=>p.k===k) && ERKLAERT[k]){
    boxen.push('<div class="kuno-panel__info"><h3>'+ERKLAERT[k].h+'</h3><p>'+ERKLAERT[k].t+'</p></div>');
  }
  /* Offene Luecke und die Hydroxytyrosol-Passage (Polyphenole, 13.08.2026) */
  if(result.luecke)
    boxen.push('<div class="kuno-panel__info"><h3>Offene Lücke</h3><p>'+result.luecke+'</p></div>');
  if(result.hydroxytyrosol)
    boxen.push('<div class="kuno-panel__info"><h3>Hydroxytyrosol und der zugelassene Wortlaut</h3><p>'+result.hydroxytyrosol+'</p></div>');
  let dl='<b>'+(result.evidence||'—')+'</b>';
  /* Pflicht-Datenlage-Zeile: formuliert eine Antwort ihre Datenlage
     selbst, gilt genau dieser Wortlaut. */
  if(result.datenlage){
    dl='<b>'+result.datenlage+'</b>';
  } else if(liste.length){
    const notiert=liste.filter(p=>p.n).length, ohneMenge=liste.filter(p=>!grundpreis(p)).length;
    /* verkostet zaehlt seit 15.08.2026 echte Profile statt einer harten 0. */
    const verkostet=liste.filter(p=>p.sens).length;
    dl='<b>'+liste.length+' von '+liste.length+'</b> mit Preis und Lieferbarkeit aus dem Shop.<br>'
      +'<b>'+notiert+' von '+liste.length+'</b> mit Geschmacksnotiz aus dem Produkttext.<br>'
      +'<b>'+verkostet+' von '+liste.length+'</b> verkostet'
      +(verkostet?' — Geschmacksstärke von 1 bis 10.':' — die Sensorik wird gerade erhoben.')
      +(ohneMenge?'<br><b>'+ohneMenge+'</b> ohne Füllmenge im Titel, dort steht keine Zahl.':'');
  }
  boxen.push('<div class="kuno-panel__info kuno-panel__info--daten"><h3>Datenlage</h3><p>'+dl+'</p></div>');
  if(result.eigen)  boxen.push('<div class="kuno-panel__info"><h3>Selbst probiert</h3><p>'+result.eigen+'</p></div>');
  if(result.why)    boxen.push('<div class="kuno-panel__info"><h3>Warum diese Auswahl</h3><p>'+result.why+'</p></div>');
  if(result.limit)  boxen.push('<div class="kuno-panel__info"><h3>Grenze</h3><p>Passt eher nicht, wenn '+result.limit+'</p></div>');
  if(result.source) boxen.push('<div class="kuno-panel__info"><h3>Quelle</h3><p>'+result.source+'</p></div>');
  el('side').innerHTML=boxen.join('');
}

function vergleichHtml(v){
  const p=x=>'<div class="p"><img src="'+x.i+'" alt=""><b>'+kurz(x.t)+'</b>'+mengeText(x)+'<br>'+eur(x.p)+'</div>';
  return '<div class="vprod">'+p(v.a)+p(v.b)+'</div>'
   +'<table><thead><tr><th></th><th>'+kurz(v.a.t)+'</th><th>'+kurz(v.b.t)+'</th><th>Unterschied</th></tr></thead><tbody>'
   +v.zeilen.map(z=>'<tr><td>'+z.feld+'</td><td>'+z.a+'</td><td>'+z.b+'</td><td class="u">'+z.u+'</td></tr>').join('')
   +'</tbody></table>';
}

function rechnungHtml(r){
  let h='<div class="rbox hl"><div class="kl">'+r.stoff+' in '+zahl(r.menge)+' g</div>'
   +'<div class="gross">'+zahl(r.ergebnis)+' '+r.einheit+'</div>'
   +'<div class="kl">Grundlage: '+zahl(r.basis)+' '+r.einheit+' je 100 g · Belegstufe Etikett</div></div>'
   +'<div class="rbox"><div class="kl">Rechnung</div><code>'+r.formel+'</code></div>';
  if(r.anteil!==null&&r.anteil!==undefined){
    h+='<div class="rbox"><div class="kl">Zum Vergleich</div><div class="gross">'+r.anteil+' %</div>'
      +'<div class="kl">'+r.referenz+'</div></div>';
  }
  return h;
}

/* Textfelder des Zweitblocks werden ueber innerHTML gesetzt - anders
   als oben, wo textContent greift. Deshalb hier maskieren. */
function sicher(t){
  return String(t==null?'':t).replace(/&/g,'&amp;').replace(/</g,'&lt;')
    .replace(/>/g,'&gt;').replace(/"/g,'&quot;');
}

/* Der zweite Antwortblock wird beim ersten Bedarf angelegt und vor
   "Passt dazu" eingehaengt - das Snippet-DOM bleibt unveraendert,
   keine ID wird umbenannt. */
function zweitBox(){
  let b=el('kunoZweite');
  if(!b){
    const d=el('dazu');
    if(!d || !d.parentNode) return null;
    b=document.createElement('section');
    b.id='kunoZweite';
    b.className='kuno-zweit';
    b.hidden=true;
    d.parentNode.insertBefore(b,d);
  }
  return b;
}
/* Zwei Themen in einer Frage: der zweite Antwortblock steht unter dem
   ersten Produktraster und damit fast immer ausserhalb des Bildschirms.
   Alexander am 16.08.2026 zu "Ich haette gerne Olivenoel und Honig":
   "Da kommt dann nur Olivenoel." Der Honig kam sehr wohl - neun Karten
   weiter unten. Deshalb oben eine Sprungleiste, die beide Themen nennt
   und anspringbar macht. Reine Optik, die Logik bleibt unberuehrt.
   Gestaltet ueber Inline-Werte, damit dafuer keine zweite Datei
   angefasst werden muss. */
function zweitHinweis(alle){
  let h=el('kunoThemen');
  const nach=el('ergIntro');
  if(!h){
    if(!nach || !nach.parentNode) return;
    h=document.createElement('div');
    h.id='kunoThemen';
    h.className='kuno-themen';
    h.style.cssText='display:flex;flex-wrap:wrap;align-items:center;gap:10px;margin:14px 0 2px';
    nach.parentNode.insertBefore(h, nach.nextSibling);
  }
  if(!alle || alle.length<2){ h.hidden=true; h.innerHTML=''; return; }
  const kurz=r=>sicher(String(r.title||r.eyebrow||'Antwort').split('|')[0].split(',')[0].trim()).slice(0,40);
  const knopf='display:inline-flex;align-items:center;gap:7px;border:1px solid currentColor;background:transparent;color:inherit;border-radius:999px;padding:6px 14px;font:inherit;font-size:14px;cursor:pointer;opacity:.92';
  h.hidden=false;
  h.innerHTML='<span style="font-size:13px;letter-spacing:.08em;text-transform:uppercase;opacity:.7">Zwei Themen erkannt</span>'
    +'<button type="button" data-springe="oben" style="'+knopf+'">1 · '+kurz(alle[0])+'</button>'
    +'<button type="button" data-springe="zweit" style="'+knopf+'">2 · '+kurz(alle[1])+'</button>';
  h.querySelectorAll('[data-springe]').forEach(b=>b.addEventListener('click',()=>{
    const ziel = b.dataset.springe==='zweit' ? el('kunoZweite') : el('ergTitle');
    if(ziel) ziel.scrollIntoView({behavior:'smooth',block:'start'});
  }));
}
function zweitBlockHtml(r){
  const liste=(!r.noProduct && r.pick) ? r.pick() : [];
  let h='<div class="kuno-zweit__kopf">'
   +'<span class="kuno-zweit__eyebrow">Auch gefragt \u00b7 '+sicher(r.eyebrow||'Antwort')+'</span>'
   +'<h2>'+sicher(r.title||'')+'</h2>'
   +(r.intro?'<p>'+sicher(r.intro)+'</p>':'')
   +(r.redirect?'<p>'+sicher(r.redirect)+'</p>':'')
   +'</div>';
  const ms=r.metrics||[];
  if(ms.length) h+='<div class="kuno-zweit__metrics">'
    +ms.map(m=>'<div class="metric"><strong>'+sicher(m[0])+'</strong><span>'+sicher(m[1])+'</span></div>').join('')
    +'</div>';
  if(liste.length) h+='<div class="kuno-zweit__grid">'+liste.map(karte).join('')+'</div>';
  const dl=r.datenlage||r.evidence;
  if(dl)       h+='<div class="kuno-panel__info kuno-panel__info--daten"><h3>Datenlage</h3><p><b>'+sicher(dl)+'</b></p></div>';
  if(r.luecke) h+='<div class="kuno-panel__info"><h3>Offene L\u00fccke</h3><p>'+sicher(r.luecke)+'</p></div>';
  if(r.source) h+='<div class="kuno-panel__info"><h3>Quelle</h3><p>'+sicher(r.source)+'</p></div>';
  return h;
}
/* Eigene Regeln nur fuer den Zweitblock. Farben werden geerbt, damit
   das Tiefgruen-Design vom 14.08. die eine Quelle der Wahrheit bleibt. */
(function(){
  if(document.getElementById('kunoZweitCss')) return;
  const st=document.createElement('style');
  st.id='kunoZweitCss';
  st.textContent='.kuno-zweit{margin-top:2.5rem;padding-top:2rem;border-top:1px solid rgba(255,255,255,.18)}'
   +'.kuno-zweit[hidden]{display:none}'
   +'.kuno-zweit__eyebrow{display:block;font-size:.78rem;letter-spacing:.08em;text-transform:uppercase;opacity:.75;margin-bottom:.35rem}'
   +'.kuno-zweit__kopf h2{margin:.1rem 0 .5rem}'
   +'.kuno-zweit__grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(200px,1fr));gap:16px;margin:1rem 0}'
   +'.kuno-zweit__metrics{display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));gap:12px;margin:1rem 0}';
  document.head.appendChild(st);
})();

/* Nimmt seit 16.08.2026 eine Liste entgegen. Ein einzelnes Ergebnis
   bleibt erlaubt, damit nichts umgeschrieben werden muss, was schon
   render(x) aufruft. */
function render(ergebnisse){
  const alle = Array.isArray(ergebnisse) ? ergebnisse : [ergebnisse];
  const result = alle[0];
  current=alle;
  const roh=(!result.noProduct && result.pick) ? result.pick() : [];
  baueFilter(roh);
  const liste=sortiere(aktiveFilter.length ? roh.filter(p=>notizen(p).some(n=>aktiveFilter.includes(n))) : roh);

  el('ergEyebrow').textContent=result.eyebrow||'Antwort';
  el('ergTitle').textContent  =result.title||'';
  el('ergIntro').textContent  =result.intro||'';
  el('ergCount').textContent  = liste.length
    ? (liste.length===roh.length ? liste.length+' Artikel im Sortiment' : liste.length+' von '+roh.length+' Artikeln')
    : '';

  const typ=result.bannerType||'arzt';
  if(result.redirect){
    el('textcol').style.display='block';
    el('textHead').textContent=KOPF[typ];
    el('textSub').textContent=(NACH[typ]?NACH[typ]+' ':'')+result.redirect;
    el('zutaten').innerHTML=(result.tags||[]).filter(t=>/^[a-zäöüß]+$/i.test(t)&&t.length<14)
      .map(w=>'<button class="kchip" data-chip="'+w+'">'+w+'</button>').join('');
  } else el('textcol').style.display='none';

  el('vergleich').style.display=result.vergleich?'block':'none';
  if(result.vergleich) el('vergleich').innerHTML=vergleichHtml(result.vergleich);

  el('rechnung').style.display=result.rechnung?'grid':'none';
  if(result.rechnung) el('rechnung').innerHTML=rechnungHtml(result.rechnung);

  el('rezepte').style.display=result.rezept?'grid':'none';
  if(result.rezept) el('rezepte').innerHTML=result.rezept.artikel.map(rezeptKarte).join('');

  el('erzeuger').style.display=result.erzeuger?'grid':'none';
  if(result.erzeuger) el('erzeuger').innerHTML=result.erzeuger.artikel.map(erzeugerKarte).join('');

  const ms=result.metrics||[];
  el('metrics').style.display=ms.length?'grid':'none';
  el('metrics').innerHTML=ms.map(([v,l])=>'<div class="metric"><strong>'+v+'</strong><span>'+l+'</span></div>').join('');

  const ch=(result.noProduct&&result.choice)?result.choice:[];
  el('choice').style.display=ch.length?'grid':'none';
  el('choice').innerHTML=ch.map(o=>'<button type="button" class="cc" data-chip="'+o.ask.replace(/"/g,'&quot;')+'"><strong>'+o.title+'</strong><span>'+o.desc+'</span></button>').join('');

  el('grid').innerHTML=liste.map(karte).join('');
  el('grid').style.display=liste.length?'grid':'none';
  seitenspalte(result,liste);

  /* Werkzeugzeile (Filter + Sortierung) nur zeigen, wenn ein Raster da ist */
  el('kunoTools').style.display=liste.length?'flex':'none';

  /* Passt dazu - nie bei einer gesperrten oder umgelenkten Frage */
  /* Zweiter Antwortblock */
  const box=zweitBox();
  if(box){
    if(alle.length>1){ box.innerHTML=zweitBlockHtml(alle[1]); box.hidden=false; }
    else { box.innerHTML=''; box.hidden=true; }
  }
  zweitHinweis(alle);

  const dazu=(result.noProduct||result.redirect)?null:passtDazu(liste);
  el('dazu').style.display=dazu?'block':'none';
  if(dazu) el('dazu').innerHTML='<h2>Passt dazu</h2><div class="g">'+dazu.grund+'</div>'
    +'<div id="dazuGrid">'+dazu.artikel.map(karte).join('')+'</div>';
}

/* ---- Tracking: jede Frage wird gezählt, damit sichtbar wird, was
   Kundinnen und Kunden wirklich suchen. Gemeldet wird an den
   dataLayer (Google Tag Manager → GA4) und an Shopify-Analytics.
   Kein Name, keine Kennung — nur die Frage und was daraus wurde. ---- */
/* Stand der Wissensschicht. Wird bei jeder Frage mitgeschickt, damit
   eine alte Frage spaeter mit genau der Fassung nachgestellt werden
   kann, die damals geantwortet hat. Bei jeder Aenderung an der Logik
   hochzaehlen. */
const KUNO_VERSION = '2026-08-15';

function trackeFrage(frage, ergebnis, treffer, quelle){
  /* Seit 16.08.2026 kann eine Frage zwei Antworten haben. Antwortart,
     Rubrik und Titel werden deshalb kommagetrennt gemeldet - sonst
     waere die zweite Antwort in GA4 unsichtbar. */
  const alle = Array.isArray(ergebnis) ? ergebnis : [ergebnis];
  const erste = alle[0];
  const art = alle.map(r => (typeof nameOf === 'function') ? nameOf(r) : '').filter(Boolean).join(',');
  /* Verstanden, sobald IRGENDEIN Teil der Frage beantwortet wurde.
     kuno_ohne_antwort feuert damit nicht mehr bei halb beantworteten
     Fragen. */
  const verstanden = alle.some(r => !(typeof results !== 'undefined' && r === results.generic));
  const daten = {
    kuno_frage: frage,
    kuno_antwortart: art,
    kuno_rubrik: alle.map(r => r.eyebrow || '').filter(Boolean).join(','),
    kuno_titel: alle.map(r => r.title || '').filter(Boolean).join(' | ').slice(0, 90),
    kuno_treffer: treffer,
    kuno_antworten: alle.length,
    kuno_verstanden: verstanden,
    kuno_gesperrt: alle.some(r => !!r.noProduct),
    kuno_umgelenkt: alle.some(r => !!r.redirect),
    kuno_quelle: quelle || 'feld',
    kuno_version: KUNO_VERSION
  };
  try {
    window.dataLayer = window.dataLayer || [];
    /* Standardereignis, damit die Frage in GA4 ohne Zusatzarbeit
       unter „search_term" auftaucht … */
    window.dataLayer.push({ event: 'search', search_term: frage, search_type: 'kuno' });
    /* … und das eigene Ereignis mit allen Einzelheiten. */
    window.dataLayer.push(Object.assign({ event: 'kuno_frage' }, daten));
    if (!verstanden) window.dataLayer.push(Object.assign({ event: 'kuno_ohne_antwort' }, daten));
  } catch (e) {}
  try {
    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
      Shopify.analytics.publish('kuno_frage', daten);
    }
  } catch (e) {}
}

/* Klick auf ein Produkt in einer Antwort — zeigt, welche Frage verkauft. */
function trackeKlick(nr, frage){
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'kuno_produktklick', kuno_frage: frage, kuno_artikel: nr });
  } catch (e) {}
}

function kunoZeigen(){
  const panel=el('frag-kuno');
  panel.hidden=false;
  kunoOffen=true;
  requestAnimationFrame(()=>{
    const top=window.scrollY+panel.getBoundingClientRect().top-70;
    window.scrollTo({top:Math.max(0,top),behavior:'smooth'});
  });
}
/* ---- Automatisches Schliessen -----------------------------------
   Das Antwortfeld steht im Seitenfluss, es liegt nicht darueber. Wer
   daran vorbeiscrollt, ist beim Rest der Seite angekommen - dann darf
   es sich schliessen. Genau das tat es schon, nur sprang die Seite
   dabei: verschwindet ein Block von 900 Pixeln aus dem Fluss, rutscht
   alles darunter um 900 Pixel nach oben, mitten in der Scrollbewegung.

   Seit 15.08.2026 wird die Scrollposition um dieselbe Hoehe korrigiert.
   Der Rest der Seite bleibt damit stehen, wo er steht; bemerkbar ist
   nur, dass der gruene Block beim Zurueckscrollen weg ist.

   Ein fester Timer waere der falsche Weg gewesen: Er haette genau die
   getroffen, die gerade lesen. Wer liest, scrollt nicht weg - und
   behaelt seine Antwort, so lange er will. */
function kunoSchliessen(grund){
  if(!kunoOffen) return;
  const panel = el('frag-kuno');
  const kasten = panel.getBoundingClientRect();
  const hoehe = kasten.height;
  const warOben = kasten.bottom <= 40;
  panel.hidden = true;
  kunoOffen = false;

  if(grund === 'scroll'){
    if(warOben) window.scrollBy(0, -hoehe);
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event:'kuno_auto_geschlossen', kuno_frage: letzteFrage || '' });
    } catch (e) {}
  } else {
    /* Von Hand geschlossen. Der Knopf verspricht „Zurueck zur
       Startseite" - dann soll die Seite auch dort landen. */
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}

function ask(v, quelle){
  v=(v||'').trim();
  if(!v){ el('q').focus(); return; }
  if(v!==el('q2').value) aktiveFilter=[];
  const alle=classifyAlle(v);
  const r=alle[0];
  if(r.vorfilter && r.vorfilter.length) aktiveFilter=r.vorfilter.slice();
  render(alle);
  el('q').value=v; el('q2').value=v;
  letzteFrage=v;
  trackeFrage(v, alle,
    alle.reduce((n,x)=>n+((!x.noProduct && x.pick) ? x.pick().length : 0), 0), quelle);
  kunoZeigen();
}
let letzteFrage='';

function starten(){
  el('askBtn') && el('askBtn').addEventListener('click',e=>{e.preventDefault();ask(el('q').value)});
  const heroForm=document.querySelector('[data-kuno-form]');
  if(heroForm) heroForm.addEventListener('submit',e=>{e.preventDefault();ask(el('q').value)});
  el('askBtn2').addEventListener('click',()=>ask(el('q2').value));
  el('q').addEventListener('keydown',e=>{if(e.key==='Enter'){e.preventDefault();ask(e.target.value)}});
  el('q2').addEventListener('keydown',e=>{if(e.key==='Enter'){e.preventDefault();ask(e.target.value)}});
  /* Wie eine Suchmaschine: beim Reingehen steht der alte Text markiert da,
     ein neuer Tastendruck ersetzt ihn. Kein Handloeschen mehr noetig. */
  el('q').addEventListener('focus',()=>el('q').select());
  el('q2').addEventListener('focus',()=>el('q2').select());
  const heroClear=document.querySelector('[data-kuno-clear]');
  if(heroClear){
    el('q').addEventListener('input',()=>{heroClear.hidden=!el('q').value;});
    heroClear.addEventListener('click',()=>{el('q').value='';heroClear.hidden=true;el('q').focus();});
  }
  el('clearBtn').addEventListener('click',()=>{el('q2').value='';el('q2').focus()});
  el('sortSel').addEventListener('change',()=>render(current));
  window.addEventListener('keydown',e=>{if(e.key==='Escape'&&kunoOffen)kunoSchliessen();});
  window.addEventListener('scroll',()=>{
    if(!kunoOffen) return;
    if(el('frag-kuno').getBoundingClientRect().bottom<40) kunoSchliessen('scroll');
  },{passive:true});
  document.body.addEventListener('click',e=>{
    const x=e.target.closest('[data-kuno-close]'); if(x){ kunoSchliessen(); return; }
    const f=e.target.closest('[data-filter]');
    if(f){ const w=f.dataset.filter;
      aktiveFilter = aktiveFilter.includes(w) ? aktiveFilter.filter(y=>y!==w) : aktiveFilter.concat(w);
      render(current); return; }
    const p=e.target.closest('.pcard[data-nr]');
    if(p){ trackeKlick(p.dataset.nr, letzteFrage); }
    const c=e.target.closest('[data-chip]'); if(c){ ask(c.dataset.chip,'zutat'); return; }
    const k=e.target.closest('[data-kuno-query]'); if(k) ask(k.dataset.kunoQuery,'beispiel');
  });
  liveAbgleich();
}
starten();
